import { Injectable, Injector } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { startWith } from 'rxjs/internal/operators/startWith';
import { catchError, finalize } from 'rxjs/operators';
import { WorkspaceState } from 'src/app/_shared/state/workspace.state';
import { AppState } from 'src/app/app.state';
import { CmaState } from 'src/app/cma/cma.state';
import { ReportsState } from 'src/app/reports/reports.state';
import { SearchService } from 'src/app/workspace/service/search.service';
import { PropertyState } from 'src/app/workspace/state/property.state';
import { ProspektrApi } from '../api/prospektr.api';
import { PublicRecordApi } from '../api/public-record.api';
import { Json } from '../interface/common.interface';
import { ClusteredProperty, PartialProperty } from '../interface/property.interface';
import { FilterService } from './filter.service';

@Injectable({
  providedIn: 'root',
})
export class PropertyService {
  constructor(
    private publicRecordApi: PublicRecordApi,
    private propertyState: PropertyState,
    private snackBar: MatSnackBar,
    private workspaceState: WorkspaceState,
    private appState: AppState,
    private cmaState: CmaState,
    private reportsState: ReportsState,
    private injector: Injector,
    private filterService: FilterService,
    private prospektrApi: ProspektrApi
  ) { }

  hasSharedPMXProperty = true;

  getPropertyDetails(propertyObj) {
    this.workspaceState.propertyDetailsSheetLoaderValue = true;
    const searchService = this.injector.get(SearchService);

    this.publicRecordApi.getPropertyDetails(propertyObj).subscribe(
      (res) => {
        this.workspaceState.propertyDetailsSheetLoaderValue = false;
        if (res && res.status && res.statusCode === 200 && res.data) {
          let filterStyleClassfromlist = this.getPropertyStatus(res.data?.basic);
          res.data.basic['filterStyleClass'] = filterStyleClassfromlist;
          const homeValueParams = {
            City: res.data.basic?.City,
            State: res.data.basic?.StateOrProvince,
            StreetName: this.getStreetName(res.data.basic),
            StreetNumber: res.data.basic?.StreetNumber,
            Zip: res.data.basic?.PostalCode,
          };
          this.getHomeValue(homeValueParams);
          this.propertyState.activePropertyDetailsValue = res.data;
          if (this.propertyState.sharedPMXPropertyValue && this.hasSharedPMXProperty) {
            let fullAddress = res.data.basic.Address;
            searchService.getPropertyList(fullAddress);
            this.hasSharedPMXProperty = false;
          }
        } else {
          this.propertyState.activePropertyDetailsValue = {};
          if (this.propertyState.sharedPMXPropertyValue) {
            if (this.appState.authTokenValue?.idToken) {
              searchService.getLastSearch();
            } else {
              searchService.fetchUserLocation();
            }
            this.propertyState.sharedPMXPropertyValue = null;
          }
        }
      },
      (err) => {
        this.workspaceState.propertyDetailsSheetLoaderValue = false;
        this.propertyState.activePropertyDetailsValue = {};
        if (this.propertyState.sharedPMXPropertyValue) {
          if (this.appState.authTokenValue?.idToken) {
            searchService.getLastSearch();
          } else {
            searchService.fetchUserLocation();
          }
          this.propertyState.sharedPMXPropertyValue = null;
        }
      }
    );
    //  }
  }

  private valueSource = new BehaviorSubject<any>(null);
  currentValue$ = this.valueSource.asObservable();

  onClosePropertyDetailsSheet(value: any) {
    this.valueSource.next(value);
  }

  getStreetName(res) {
    let streetName = res.StreetName;
    if (res.StreetDirPrefix) streetName = res.StreetDirPrefix + ' ' + streetName;
    if (res.StreetSuffix) streetName = streetName + ' ' + res.StreetSuffix;
    if (res.StreetDirSuffix) streetName = streetName + ' ' + res.StreetDirSuffix;
    return streetName;
  }

  getHomeValue(params) {
    this.publicRecordApi.getHomeValue(params).subscribe((res) => {
      if (res && res.status && res.status.message && res.status.message === 'Success' && res.data) {
        this.propertyState.activeHomeValueData = res.data;
      } else {
        this.propertyState.activeHomeValueData = null;
      }
    });
  }

  getRentalListings(params): Observable<{ isLoading?: boolean; data?: any }> {
    return new Observable((observer) => {
      observer.next({ isLoading: true });
      this.publicRecordApi
        .getRentalListing(params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res: any) => {
            if (res?.status && res?.message === 'Success' && res?.data) {
              const response = this.expandMinifiedResponseFromApi(res.data.FieldNameMapping, res.data.Records);

              observer.next({
                isLoading: false,
                data: response,
              });
            } else {
              observer.next({
                isLoading: false,
                data: null,
              });
            }
          },
          () => {
            observer.next({
              isLoading: false,
              data: null,
            });
          }
        );
    });
  }

  getPropertyStatus(property: any): string {
    let propertyFiltered = this.filterService.isBasePropertyFiltered(property);
    if (propertyFiltered.status) {
      if (propertyFiltered.filter.includes('distressed')) return 'distressed';
      if (propertyFiltered.filter.includes('hud')) return 'hud';
      if (propertyFiltered.filter.includes('listing')) return 'listing';
      if (propertyFiltered.filter.includes('sold')) return 'sold';
      return 'filtered';
    }
    return 'nonFiltered';
  }

  // filterPropertyStatus(property) {
  //   let validFilterList = [];
  //   let status = true;
  //   if (
  //     property.Lst_StandardStatus == 'Active' ||
  //     (property.Lst_StandardStatus == 'Active Under Contract' && property.Lst_speciallistingconditions == 'Standard')
  //   ) {
  //     status = true;
  //     validFilterList.push('listing');
  //   }
  //   if (
  //     (property.Lst_StandardStatus == 'Active' || property.Lst_StandardStatus == 'Active Under Contract') &&
  //     property.Lst_specialListingConditions == 'Standard'
  //   ) {
  //     status = true;
  //     validFilterList.push('listing');
  //   }
  //   if (
  //     property.Lst_StandardStatus == 'Sold' &&
  //     property.Lst_specialListingConditions == 'Standard' &&
  //     property.Fcl_Status == null
  //   ) {
  //     status = true;
  //     validFilterList.push('sold');
  //   }
  //   if (property.Lst_StandardStatus == 'Active' && property.Lst_specialListingConditions == 'Short Sale') {
  //     status = true;
  //     validFilterList.push('distressed');
  //   }
  //   if (
  //     property.Lst_StandardStatus == 'Sold' &&
  //     property.Lst_specialListingConditions == 'Standard' &&
  //     property.Fcl_Status == 'AUCTION'
  //   ) {
  //     status = true;
  //     validFilterList.push('distressed');
  //   }
  //   if (property.Lst_StandardStatus == 'Pending' && property.Lst_specialListingConditions == 'Real Estate Owned') {
  //     status = true;
  //     validFilterList.push('distressed');
  //   }
  //   if (
  //     property.Lst_StandardStatus == 'Active' &&
  //     property.Lst_specialListingConditions == 'Standard,Fannie Mae Owned'
  //   ) {
  //     status = true;
  //     validFilterList.push('hud');
  //   }
  //   return { status, filter: validFilterList };
  // }

  getAddressComponentsFromStandardAddress(standardAddress: string): Json {
    let addressComponentList = standardAddress?.split(',');

    if (!addressComponentList || addressComponentList?.length < 3) return null;

    let stateAndZip = addressComponentList[2];
    let stateAndZipList = stateAndZip?.split(' ');
    let addressComponent: any = {
      StreetAddress: addressComponentList[0],
      City: addressComponentList[1],
      State: stateAndZipList[1],
      PostalCode: stateAndZipList[2],
    };
    return addressComponent;
  }

  getToken(): Observable<any> {
    return new Observable((observer) => {
      this.publicRecordApi.getToken().subscribe(
        (res) => {
          if (res && res.data && res.data.token) {
            observer.next(res.data.token);
          }
        },
        (err) => {
          observer.error(err.error);
        }
      );
    });
  }

  getListingDetailsByCompleteAddress(params, flag): Observable<any> {
    if (flag === 'cma') {
      this.cmaState.isLoadingCreateReport = true;
    } else {
      this.reportsState.isLoadingCreateReport = true;
    }

    return new Observable((observer) => {
      this.publicRecordApi.getListingDetailsByCompleteAddress(params).subscribe(
        (res) => {

          if (flag === 'cma') {
            this.cmaState.isLoadingCreateReport = false;
          } else {
            this.reportsState.isLoadingCreateReport = false;
          }

          if (res && res.data) {
            observer.next(res.data);
          } else {
            observer.next(null);
          }

          observer.complete();

        },
        (err) => {

          if (flag === 'cma') {
            this.cmaState.isLoadingCreateReport = false;
          } else {
            this.reportsState.isLoadingCreateReport = false;
          }

          observer.error(err.error);

        }
      );
    });
  }


  addSellerProperty(params): Observable<any> {
    return this.prospektrApi.addSellerProperty(params).pipe(
      startWith({ isLoading: true }), // Emits loading state first
      catchError((err) => {
        return of({ error: true, message: 'Failed to add seller property', details: err });
      }),
      finalize(() => { })
    );
  }

  getBoundingBox(params: { lat: number; lng: number; distanceInMiles: number }) {
    const { lat, lng, distanceInMiles } = params;
    const latOffset = distanceInMiles / 69;
    const lngOffset = distanceInMiles / (69.172 * Math.cos((lat * Math.PI) / 180));
    return {
      NELatitude: lat + latOffset,
      NELongitude: lng + lngOffset,
      SWLatitude: lat - latOffset,
      SWLongitude: lng - lngOffset,
    };
  }

  /**
   * Expands the minified response received from the API using the field and record mapping
   */
  expandMinifiedResponseFromApi(
    fields: { [key: string]: string },
    recordList: Array<any>
  ): PartialProperty[] | ClusteredProperty[] {
    const invertedFilter = {};
    let expandedList = [];
    if (fields && Object.keys(fields)?.length && recordList?.length) {
      Object.keys(fields).forEach((key) => {
        invertedFilter[fields[key]] = key;
      });
      expandedList = recordList.map((record) => {
        const expandedRecord = {};
        Object.keys(record).forEach((key) => {
          expandedRecord[invertedFilter[key]] = record[key];
        });
        return expandedRecord;
      });
    }
    return expandedList;
  }
}
